
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto max-w-l mt-6 p-2">
      <h1 className="text-3xl font-bold text-blue-400 mb-6">Free4Talk Privacy Policy</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-yellow-400">Introduction</h2>
        <p className="mt-2">
          This policy describes what information we collect when you use Free4Talk application. It also provides information about how we store, transfer, use, and delete that information, and what choices you have with respect to the information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold text-yellow-400">How we collect your information from Google</h2>
        <p className="mt-2">
          Following <a href="#" className="text-blue-400">Google API Services User Data Policy</a>
        </p>
        <ul className="list-disc list-inside mt-2">
          <li>By <strong>Sign In With Google</strong> we collect your <strong>Google Id, Email, Profile Picture, First Name and Last Name</strong> to store in database and display in Free4Talk website.</li>
          <li>The scopes we use in Google Login:
            <ul className="list-disc list-inside ml-4">
              <li>.../auth/userinfo.email: View your email address</li>
              <li>.../auth/userinfo.profile: See your personal info, including any personal info you've made publicly available</li>
              <li>openid: Associate you with your personal info on Google</li>
            </ul>
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold text-yellow-400">How we process media (audio/video/screen)</h2>
        <p className="mt-2">
          We will never store any media sent between participants in a room. Customers who have access to the “Recording” feature will be able to record meetings, and they are then responsible for collecting consents from all participants in the meeting prior to starting the recording.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-yellow-400">Changes to this policy</h2>
        <p className="mt-2">
          We can change these Terms at any time. We keep a historical record of all changes to our Terms on GitHub. If a change is material, we'll let you know before it takes effect.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
